module.exports = __webpack_public_path__ + "media/applications/assets/images/logo-4df7728f129c33697d34f0173e0b9f4a.svg";